import { FC, useState } from 'react';
import styled from 'styled-components';
import { editorTheme } from '../../theme';
import ImageWidget from './ImageWidget';
import VideoWidget from './VideoWidget';

enum MediaType {
  Images = 'Images',
  Videos = 'Videos',
}

const Toggle = styled.div`
  display: flex;
  padding: 3px;
  margin-bottom: 8px;
  border-radius: 8px;
  background: ${editorTheme.surfaceMuted};
`;

const ToggleButton = styled.button<{ selected: boolean }>`
  flex: 1;
  height: 32px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: ${({ selected }) => (selected ? 600 : 400)};
  color: ${({ selected }) =>
    selected ? editorTheme.text : editorTheme.textMuted};
  background: ${({ selected }) =>
    selected ? editorTheme.surface : 'transparent'};
  box-shadow: ${({ selected }) =>
    selected ? '0 1px 3px rgba(30, 20, 60, 0.12)' : 'none'};
`;

const MediaWidget: FC = () => {
  const [mediaType, setMediaType] = useState(MediaType.Images);

  return (
    <>
      <Toggle role="tablist" aria-label="Media type">
        {Object.values(MediaType).map((type) => (
          <ToggleButton
            key={type}
            role="tab"
            aria-selected={mediaType === type}
            selected={mediaType === type}
            onClick={() => setMediaType(type)}
          >
            {type}
          </ToggleButton>
        ))}
      </Toggle>
      {mediaType === MediaType.Images ? <ImageWidget /> : <VideoWidget />}
    </>
  );
};

export default MediaWidget;
